// node-modules
import React from 'react';
import { CloseIcon, View } from '@upstox/upstox-ui';
// services
import { ChartSyncPhase } from 'modules/ChartSync/typings';
// styles
import * as css from './styles';
// components
import ChartSyncProgress from './components/ChartSyncProgress';
import ChartSyncSuccess from './components/ChartSyncSuccess';

interface ChartSyncProgressModalProps {
  currentPhase: ChartSyncPhase;
  onClose: () => void;
}

const ChartSyncProgressModal = ({
  currentPhase,
  onClose,
}: ChartSyncProgressModalProps) => {
  const getContentBasedOnStep = () => {
    switch (currentPhase) {
      case 'PROGRESS':
        return <ChartSyncProgress />;
      case 'SUCCESS':
        return <ChartSyncSuccess onDone={onClose} />;
      default:
        return <React.Fragment />;
    }
  };

  return (
    <View css={css.modalContainer}>
      <View css={css.backdrop}>
        <View flexDirection="column" css={css.base}>
          <View css={css.header} justifyContent="flex-end" padding="medium">
            {currentPhase !== 'PROGRESS' && <CloseIcon onClick={onClose} cursor="pointer" size="large" />}
          </View>
          {getContentBasedOnStep()}
        </View>
      </View>
    </View>
  );
};

export default ChartSyncProgressModal;
